
import React, {useState} from 'react';
import './main.css';

const Nav = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
    <>
        <div className="header">
            <b className="header_textBig TypeWriter typewriter_app_title">React Apps</b>
            <br />
        </div>

        {/* MOBILE NAV BAR TOGGLE*/}
        <button className="toggle-button" aria-label="Toggle menu" onClick={() => setMenuOpen(!menuOpen)}>
            <span className="bar"> </span>
            <span className="bar"> </span>
            <span className="bar"> </span>
        </button>
        {/* NAVIGATION BAR */}
        <nav className="navbar">
            <div className={"navbar-links menu-font" + (menuOpen ? " active" : "")}>
                <ul>
                <li><a href="https://www.aidanvenckus.com/index.html">Home</a></li>
                <li><a href="https://www.aidanvenckus.com/resume.html">Resume</a></li>
                <li><a href="https://www.aidanvenckus.com/3DModels.html">3D Models</a></li>
                <li><a href="https://www.aidanvenckus.com/Projects.html">Projects</a></li>
                <li><a href="#top" className="currentpage">Apps</a></li>
                <li><a href="https://www.aidanvenckus.com/PCB.html">PCB Design</a></li>
                </ul>
            </div>
        </nav>
    </>
    );
  };

  export default Nav;
